export default __webpack_public_path__ + "static/media/Tax.326d6795.xlsx";